export class SystemUser
{
    FullName: string;
    UserName: string;
    Email: string;
}